import React from "react";
import Accordian from "../../../elements/Accordian";
import TitleDecoration from "../../../elements/TitleDecoration";
import Image from "../../../elements/Image";
import FaqImage from "../../../../assets/images/faq-image.svg";
import { useBanner } from "../../../../providers/BannerProviders";
import useFetch from "../../../../hooks/useFetch";
import { faqListFont } from "../../../../services/faqService";

const HomeFaq = () => {
  const {
    data: accordionData,
    error,
    isLoading,
    updateData,
    isFetching,
    refetch,
  } = useFetch({
    dependencies: ["homefaq"],
    fetchFunction: async () => {
      const res = await faqListFont({
        type: "faq",
      });

      if (res?.docs?.status === 200) {
        return (res?.docs?.data || [])?.map((item) => ({
          ...item,
          _id: item?._id,
          title: item?.title,
          content: item?.description,
          image: item?.image?.url,
        }));
      } else {
        return [];
      }
    },
  });

  const { data } = useBanner();
  const homeFaq = data?.data?.find((item) => item?.slug === "turn-photos-into-magic-coloring-books-1747829520846");
  const faq = homeFaq?.details?.faq;

  return (
    <>
      {/* {faq?.title || ""} {faq?.description || ""} */}
      <section className="relative py-16 overflow-hidden bg-md-pink-light-2">
        <div className="relative w-full px-4 sm:px-0 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl 3xl:max-w-8xl mx-auto">
          <div className="space-y-16">
            <div className="space-y-6 text-center">
              <h2 className="text-5xl 3xl:text-6xl font-semibold tracking-tight text-md-dark">Frequently Asked Questions</h2>
              <div className="text-2xl 3xl:text-3xl tracking-wide text-neutral-500 max-w-5xl 3xl:max-w-7xl mx-auto leading-snug">Have questions? We’ve got answers. Below you’ll find the most common questions about creating your personalized coloring book. From uploading photos to final delivery, we’re here to help you every step of the way.</div>
            </div>
            <div className="">
              <div className=""></div>
              <div className="">
                <Accordian data={accordionData} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeFaq;
